import { render, staticRenderFns } from "./linkCell.vue?vue&type=template&id=2b1371ae&scoped=true"
import script from "./linkCell.vue?vue&type=script&lang=js"
export * from "./linkCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1371ae",
  null
  
)

export default component.exports